import React from 'react'
import BlogPost, { BlogPostType } from '../../components/BlogPost'
import post from '../../data/blog/ako-zlepsit-spanok'
import { language } from '../../global'

const AkoZlepsitSpanok: React.FC = () => {
  return <BlogPost post={post[language as keyof typeof post] as BlogPostType} />
}

export default AkoZlepsitSpanok
